import React from 'react';
import {Text} from "@chakra-ui/react";

const H2 = ({children, ...props}) => {
    return (
        <Text as={"h2"} fontSize={{base: "sm", md: "md", lg: "lg"}} fontWeight={"bold"} {...props}>
            {children}
        </Text>
    );
};

export default H2;